import { render } from "./RecordAdd.vue?vue&type=template&id=1b1ec9dc"
import script from "./RecordAdd.vue?vue&type=script&lang=js"
export * from "./RecordAdd.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.5.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__